import styled from 'styled-components';
import { TitleMediumText } from '@prisjakt/ui/text/variants';

export const TitleMediumTextLink = styled(TitleMediumText)`
  flex: 0 1 auto;
`;
